import Label from "../../atoms/label/Label.jsx";
import SwitchInput from "../../atoms/switchInput/SwitchInput";
import styles from "./Input.module.css";
import InputType from "../../../../enums/InputType.jsx";
import Checkbox from "../../atoms/checkbox/Checkbox.jsx";
import Dropdown from "../../atoms/dropdown/Dropdown.jsx";
import Radio from "../../atoms/radio/Radio.jsx";
import Slider from "../../atoms/slider/Slider.jsx";
import TextInput from "../../atoms/textInput/TextInput.jsx";
import InputColor from "../../../../enums/InputColor.jsx";
import DataList from "../../atoms/dataList/DataList.jsx";
import { DateTime } from "../../atoms/index.jsx";
function Input({ inputType, labelText, className, name, value, onChange, inputLeft, isColumn, checked, options, bidirectional, ...props }) {
  let input;
  switch (inputType) {
    case InputType.switch:
      input = <SwitchInput onChange={onChange} value={value} {...props} />;
      break;
    case InputType.checkBox:
      input = <Checkbox onChange={onChange} checked={checked} inputColor={InputColor.blue} value={value} {...props} />;
      break;
    case InputType.dropDown:
      input = <Dropdown onChange={onChange} value={value} options={options} {...props} />;
      break;
    case InputType.radio:
      input = <Radio name={name} value={value} onChange={onChange} checked={checked} {...props} />;
      break;
    case InputType.slider:
      input = <Slider onChange={onChange} value={value} bidirectional={bidirectional} {...props} />;
      break;
    case InputType.text:
      input = <TextInput onChange={onChange} value={value} {...props} />;
      break;
    case InputType.dateTime:
      input = <DateTime className={className} name={name} value={value} onChange={onChange} {...props} />
      break
    case InputType.dataList:
      input = <DataList onChange={onChange} value={value} options={options} {...props} />
      break;
    default:
      break;
  }
  return (
    <Label className={[styles.flexContainer, isColumn ? styles.column : styles.row, className, inputLeft && styles.inputLeft].filter(e => !!e).join(' ')} labelText={labelText} {...props}>
      {input}
    </Label>
  );
}

export default Input;
